import { useState } from "react";
import { fetchWithAuth } from "../../../../api-client/api_client";
import { APIEndpointMethod } from "../../../../models/Entities";
import { showErrorToast } from "../../../shared/Toasts";
import { AutomatedModifiedAtFilterDetails } from "../types";

const useAutomatedModifiedAtFilters = (integrationID: string) => {
  const [isLoadingFilters, setIsLoadingFilters] = useState(true);
  const [amfModelsDetails, setAmfModelsDetails] = useState<AutomatedModifiedAtFilterDetails[]>([]);

  const loadAllAutomatedModifiedAtFilters = () => {
    setIsLoadingFilters(true);
    fetchWithAuth({
      path: `/integrations/selective-sync/integration/${integrationID}/automated-modified-at-filters`,
      method: APIEndpointMethod.GET,
      onResponse: (responseData: AutomatedModifiedAtFilterDetails[]) => {
        setIsLoadingFilters(false);
        setAmfModelsDetails(responseData);
      },
      onError: () => {
        setIsLoadingFilters(false);
        setAmfModelsDetails([]);
        showErrorToast("Failed to fetch automated modified at filters");
      },
    });
  };

  return {
    isLoadingFilters,
    amfModelsDetails,
    loadAllAutomatedModifiedAtFilters,
  };
};

export default useAutomatedModifiedAtFilters;
